import initNav from "./scripts/nav";
import initTheme from "./scripts/theme";
import initCounters from "./scripts/counters";
import initYear from "./scripts/year";

initNav();
initTheme();
initCounters();
initYear();
